import {
  Carousel,
  CarouselContent,
  CarouselNext,
  CarouselPrevious,
} from '@ui/components/Carousel/Carousel';
import type { HTMLAttributes, ReactNode } from 'react';
import ProductListHeader from './ProductListHeader';
import { cn } from '@ngg/storefront-utils';
import type { TailwindClasses } from '@ngg/storefront-utils';
import { Heading } from '../Heading/Heading';

type ProductListCarouselProps = HTMLAttributes<HTMLElement> & {
  carouselTitle?: string | null | undefined;
  subtitle?: ReactNode;
  carouselClassName?: TailwindClasses;
  contentClassName?: TailwindClasses;
  titleClassName?: TailwindClasses;
  nextClassName?: TailwindClasses;
  previousClassName?: TailwindClasses;
};

const ProductListCarousel = ({
  children,
  carouselTitle,
  subtitle,
  carouselClassName,
  contentClassName,
  titleClassName,
  nextClassName,
  previousClassName,
}: ProductListCarouselProps) => {
  return (
    <section>
      <div>
        {carouselTitle && (
          <ProductListHeader className={subtitle ? 'pb-0' : ''}>
            <Heading
              className={cn(
                'text-lg font-bold md:pb-2 md:text-2xl',
                titleClassName,
              )}>
              {carouselTitle}
            </Heading>
          </ProductListHeader>
        )}
        {subtitle && subtitle}
      </div>
      <Carousel
        className={cn(carouselClassName)}
        opts={{
          align: 'start',
          slidesToScroll: 'auto',
        }}>
        <CarouselContent className={cn(contentClassName)}>
          {children}
        </CarouselContent>
        <CarouselPrevious
          variant="secondary"
          className={cn('-translate-y-16', previousClassName)}
        />
        <CarouselNext
          variant="secondary"
          className={cn('-translate-y-16', nextClassName)}
        />
      </Carousel>
    </section>
  );
};

ProductListCarousel.displayName = 'ProductListCarousel';

export default ProductListCarousel;
